
import Swal from 'sweetalert2';
import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';

export default {
  name: 'ViewClientAdmin',
  components: {
    AdminNavBar,
  },
  data: () => ({
    admin_data: [],
    get_user_id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    onboarding_link: '',
    
  }),
  methods: {
    get_admin_client_details(user_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        this.showError('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const GET_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/view_user_api/${user_id}`;

      $.ajax({
        method: "GET",
        url: GET_USER_URL,
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading users...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
            this.get_user_id = response.user[0].id
            this.first_name = response.user[0].first_name;
            this.last_name = response.user[0].last_name;
            this.email = response.user[0].email;
            this.onboarding_link = response.user[0].onboarding_link;
            this.phone_number = '0' + response.user[0].phone_number;
            this.date_joined =  response.user[0].date_joined.split('T')[0];
        
            Swal.close();
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            text: 'Failed to load users. Please try again.',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    edit_user(get_user_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        this.showError('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const EDIT_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/edit_user_api/${get_user_id}`;
      const FORM_DATA = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone_number: this.phone_number
      };

      $.ajax({
        method: "POST",
        url: EDIT_USER_URL,
        data: JSON.stringify(FORM_DATA),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading users...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.fire({
            icon: 'success',
            text: response.message,
            confirmButtonText: 'OK'
          });
        },
        error: (error) => {
          Swal.fire({
            icon: 'error',
            text: error.responseJSON.error,
            confirmButtonText: 'OK'
          });
        }
      })
    },
  },
  computed: {
    filteredData() {
      return this.data[this.currentTab];
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
  }
    const user_id= this.$route.params.user_id;
    this.get_admin_client_details(user_id);
  }
};
